export default __webpack_public_path__ + "static/media/Koulen-Regular.e23002c6.ttf";